import React, { useEffect, useState } from 'react';
import Layout from '../../Layout/Layout';
import { Form } from 'react-bootstrap';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getfaq, updatefaq } from '../../actions/users';
import { toast } from 'react-toastify';
import { isEmpty } from '../../actions/commonFunction';


const initialFormValue = {
    'question': "",
    'answer': "",
}


const FaqEdit = () => {


    const navigate = useNavigate();
    const dispatch = useDispatch();


    const [validateError, setValidateError] = useState({});
  const { faqId } = useParams();
  const [question, setquestion] = useState("");
  const [answer, setanswer] = useState("");

  const onChange = (e) => {
    setquestion(e.target.value)
 
  }


  const onEditorChange = (evt) => {
    var description_text = evt;
    setanswer(description_text);
  }
  

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    let reqData = {
        question,
        answer,
        faqId
    }
    let { error } = await updatefaq(reqData);
    if (isEmpty(error)) {
     toast.success('Faq updated successfully', 1000);
      navigate('/faqlist')
    } else {
      setValidateError(error);
    }
  }

  const getFaqData = async () => {
    var test = await getfaq(faqId);
    if (test && test.userValue) {
      if (test.userValue.question) {
        setquestion(test.userValue.question)
      }
      if (test.userValue.answer) {
        setanswer(test.userValue.answer)
      }
    }
  }

  useEffect(() => {
    getFaqData();
  }, [])

    return (
        <Layout>
            <div className="faqedit">
                <Link to="/faqList" className="btn sitebtn mb-4">Back</Link>
                <h1 className="pagehead">Edit Faq</h1>
                <div className="cardbox">
                    <Form className='mb-4'>
                        <Form.Label>Question</Form.Label>
                        <Form.Control type="text" placeholder="Question" className="w-auto mb-2" onChange={onChange} id="question" value={question || ''} />
                        {
                            validateError.question && <span className='text-danger'>{validateError.question}</span>
                        }
                    </Form>

                    <Form.Label>Answer:</Form.Label>
                    {
                        answer
                        ?
                        <SunEditor height={200} defaultValue={answer} id="answer" onChange={onEditorChange} placeholder='Enter answer' />
                        :
                        <></>
                    }
                    <div className='mt-2'>
                    {
                      validateError.answer && <span className="text-danger">{validateError.answer}</span>
                    }
                    </div>

                    <button type="button" className="btn sitebtn py-2 px-3 mt-3" onClick={handleFormSubmit} >Update</button>
                </div>
            </div>
        </Layout>
    )
}

export default FaqEdit;